import React from 'react'
import PropTypes from 'prop-types'
import { Svg } from '../Svg/Svg'

function Marker({ index, isActive, onClick, ariaLabel }) {
  return (
    <button className="reset mz-map-marker" onClick={onClick} aria-label={ariaLabel}>
      <Svg
        size={3}
        colour={isActive ? 'red' : 'grey'}
        type="pin"
      />
      <span className="text--white">{index}</span>
    </button>
  )
}

Marker.propTypes = {
  index: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
}

Marker.defaultProps = {
  ariaLabel: '',
  isActive: false,
}

export default Marker